import React from "react";
import { createRoot } from "react-dom/client";
import FirstApp from "./FirstApp";
import SecondApp from "./SecondApp";
import ThirdApp from "./ThirdApp";
import { LanguageProvider } from "./utils/LanguageContext";
import { TranslationsProvider } from "./utils/TranslationsContext";
import { AlertProvider } from "./utils/AlertContext";
import { SSEProvider } from "./utils/SSEContext";
import { ThemeProvider } from "./utils/ThemeContext";
import { NotificationsProvider } from "./utils/NotificationsContext";
import { AvatarProvider } from "./utils/AvatarContext";

const mode = process.env.REACT_APP_MODE;

const App =
  mode === "first" ? (
    <LanguageProvider>
      <TranslationsProvider>
        <AlertProvider>
          <ThemeProvider>
            <AvatarProvider>
              <FirstApp />
            </AvatarProvider>
          </ThemeProvider>
        </AlertProvider>
      </TranslationsProvider>
    </LanguageProvider>
  ) : mode === "second" ? (
    <LanguageProvider>
      <TranslationsProvider>
        <AlertProvider>
          <ThemeProvider>
            <NotificationsProvider>
              <AvatarProvider>
                <SecondApp />
              </AvatarProvider>
            </NotificationsProvider>
          </ThemeProvider>
        </AlertProvider>
      </TranslationsProvider>
    </LanguageProvider>
  ) : (
    <LanguageProvider>
      <TranslationsProvider>
        <AlertProvider>
          <ThemeProvider>
            <SSEProvider>
              <NotificationsProvider>
                <AvatarProvider>
                  <ThirdApp />
                </AvatarProvider>
              </NotificationsProvider>
            </SSEProvider>
          </ThemeProvider>
        </AlertProvider>
      </TranslationsProvider>
    </LanguageProvider>
  );

const container = document.getElementById("root");

const root = createRoot(container);
root.render(App);
